import React, { Component } from "react";
import { Field } from "formik";
import { Stepper } from "react-form-stepper";
import { connect } from "react-redux";
import Dropdown from "../../../utils/Dropdown";
import style from "./CompanyInfo.module.css";
import { fetchDropdownList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { Select } from "antd";

export class CompanyInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScreenLoaded: false,
    };
  }
  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };

  goBack = () => {
    this.props.navigateBack();
  };

  goNext = () => {
    this.props.navigateNext();
  };
  goNextStpe4 = () => {
    this.props.navigateNextStep3();
  };

  render() {
    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;

    //Only Supplier and Professional service provider needs to be displayed.
    const roleIdArrayForCmpny = [1, 5];
    // getting related party role from dropdown json
    const roleOptions = dropdownData.lk_related_party_role.map(
      (element, index) => {
        if (
          roleIdArrayForCmpny.indexOf(element.lk_related_party_role_id) > -1
        ) {
          return (
            <option key={index} value={element.lk_related_party_role_id}>
              {element.role_name}
            </option>
          );
        }
      }
    );
    //getting professional service data from dropdown json
    const serviceOptions = dropdownData.lk_professional_service.map(
      (element, index) => (
        <option key={index} value={element.lk_professional_service_id}>
          {element.service_name}
        </option>
      )
    );

    //getting professional service data from dropdown json
    const industryOptions = dropdownData.lk_industry.map(
      (element, index) => (
        <option key={index} value={element.lk_industry_id}>
          {element.industry_name}
        </option>
      )
    );
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    const systemRoleOptions = dropdownData && 
    dropdownData.role.filter((opt) => opt.role_name !== 1)
    .map((opt, index) => (
      <option key={index} value={opt.role_id}>
        {opt.role_name}
      </option>
    ));
    const primarySystemRoleOptions = 
    dropdownData && dropdownData.role &&
    dropdownData.role.map((element, index) => {
     if(this.props.values.assigned_roles &&
      this.props.values.assigned_roles.length > 0 
      && this.props.values.assigned_roles.indexOf(element.role_id) > -1){
        return (
        <option key={index} value={element.role_id}>
          {element.role_name}
        </option>
        )
     }
    });

    return (
      <div className={style.companyInfoMainWrapper}>
        <div className={style.headingWrapper}>
          <h2>Step 2 : Contact Creation - Company Info</h2>
          <p>
            Please share your details as requested on the form below. 
            For system access, you can select system user role for this contact.
          </p>
          <hr />
        </div>
        <div className="row">
          <div className="col-md-10 col-xl-6">
            <div className="custom-stepper">
              <div className={style.stepperWrapper}>
              <div className="custom-stepper">
                 <ul>
                    <li>
                      <h3 onClick={this.goBack}>1</h3>
                    </li>
                    <li>
                      <h3 className="active">2</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNext}>3</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNextStpe4}>4</h3>
                    </li>
                  </ul>
                  </div>
              </div>
              {/* <div className="custom-stepper">
                <div className={style.stepperWrapper}>
                  <Stepper
                    steps={[
                      { label: "" },
                      { label: "" },
                      { label: "" },
                      { label: "" },
                    ]}
                    activeStep={0}
                    styleConfig={{
                      inactiveBgColor: "#fff",
                      activeBgColor: "#00467F",
                      inactiveTextColor: "#00467F",
                      activeTextColor: "#fff",
                      completedBgColor: "#fff",
                      completedTextColor: "#00467F",
                    }}
                    connectorStyleConfig={{
                      disabledColor: "#00467F33 ",
                      size: 2,
                    }}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div
          className={`form-controls-wrapper ${style.companyInfoFormWrapper}`}
        >
          <div className={style.relatedPartyRoleWrapper}>
            <h4>Select the Role of Contact</h4>
            <div className="row form-group">
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label>
                  Role of the contact <span className="mandatory">*</span>
                </label>
                <Field
                  as="select"
                  name="cRelatedPartyRole"
                  className={
                    "form-control" +
                    (this.props.errors.cRelatedPartyRole &&
                    this.props.touched.cRelatedPartyRole
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select a Role</option>
                  {roleOptions}
                </Field>
                {this.props.errors.cRelatedPartyRole &&
                this.props.touched.cRelatedPartyRole ? (
                  <div className={style.errMsg}>
                    {this.props.errors.cRelatedPartyRole}
                  </div>
                ) : null}
              </div>
              {this.props.values.cRelatedPartyRole == 5 && (
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label>
                    Choose a Professional Service
                    <span className="mandatory">*</span>
                  </label>
                  <Field
                    as="select"
                    name="cProfessionalService"
                    className={
                      "form-control" +
                      (this.props.errors.cProfessionalService &&
                      this.props.touched.cProfessionalService
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select a service</option>
                    {serviceOptions}
                  </Field>
                  {this.props.errors.cProfessionalService &&
                  this.props.touched.cProfessionalService ? (
                    <div className={style.errMsg}>
                      {this.props.errors.cProfessionalService}
                    </div>
                  ) : null}
                </div>
              )}
               {(this.props.values.cRelatedPartyRole && checkIfPermitted(Permissions.CREATE_SYSTEM_USERS) ) && (
                <React.Fragment>
                <div className="col-md-8 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <label htmlFor="assigned_roles">
                      Assign System Roles</label>
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      name="assigned_roles"
                      onChange={(arr) => {
                        this.props.setFieldValue("assigned_roles", [...arr]);
                        if(arr.length === 0 || (arr.indexOf(this.props.values.systemRoleParty) === -1)){
                          this.props.setFieldValue("systemRoleParty", "");
                        }
                      }}
                      placeholder="Click here to select system roles"
                      value={this.props.values.assigned_roles}
                    >
                    {systemRoleOptions}
                    </Select>
                  </div>
                </div>
                  <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <label>
                        Choose primary system role {this.props.values.assigned_roles.length > 0 && (
                        <span className="mandatory">*</span>)}
                      </label>
                    <Field
                      as="select"
                      name="systemRoleParty"
                      disabled={this.props.values.assigned_roles.length === 0}
                      onChange={this.props.handleChange}
                      className={
                        "form-control" +
                        (this.props.values.assigned_roles.length > 0 && 
                          this.props.errors.systemRoleParty && this.props.touched.systemRoleParty
                          ? " is-invalid"
                          : "")
                      }
                    >
                      <option value="">Select a primary role</option>
                      {primarySystemRoleOptions}
                    </Field>   
                      {this.props.values.assigned_roles.length > 0 && 
                          this.props.errors.systemRoleParty && this.props.touched.systemRoleParty ? (
                        <div className={style.errMsg}>{this.props.errors.systemRoleParty}</div>
                      ) : null}
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>

          <h4>Enter the below details for the Contact</h4>
          <div className="row form-group">
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="companyName">
                Name <span className="mandatory">*</span>
              </label>
              <Field
                name="companyName"
                placeholder="Name"
                value={this.props.values.companyName}
                maxLength="20"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.companyName &&
                  this.props.touched.companyName
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.companyName &&
              this.props.touched.companyName ? (
                <div className={style.errMsg}>
                  {this.props.errors.companyName}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="lineOfBusiness">
                Line of Business/Industry <span className="mandatory">*</span>
              </label>
              <Field
                as="select"
                name="lineOfBusiness"
                placeholder="Line of business"
                value={this.props.values.lineOfBusiness}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.lineOfBusiness &&
                  this.props.touched.lineOfBusiness
                    ? " is-invalid"
                    : "")
                }
              >
                <option value="">Select a Industry</option>
                {industryOptions}
                </Field>
              {this.props.errors.lineOfBusiness &&
              this.props.touched.lineOfBusiness ? (
                <div className={style.errMsg}>
                  {this.props.errors.lineOfBusiness}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="servicesOfffered">
                Services Offered <span className="mandatory">*</span>
              </label>
              <Field
                name="servicesOfffered"
                placeholder="Services Offered"
                maxLength="20"
                value={this.props.values.servicesOfffered}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.servicesOfffered &&
                  this.props.touched.servicesOfffered
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.servicesOfffered &&
              this.props.touched.servicesOfffered ? (
                <div className={style.errMsg}>
                  {this.props.errors.servicesOfffered}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="registrationNumber">
                Registration Number <span className="mandatory">*</span>
              </label>
              <Field
                name="registrationNumber"
                placeholder="Registration Number"
                value={this.props.values.registrationNumber}
                maxLength="20"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.registrationNumber &&
                  this.props.touched.registrationNumber
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.registrationNumber &&
              this.props.touched.registrationNumber ? (
                <div className={style.errMsg}>
                  {this.props.errors.registrationNumber}
                </div>
              ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="physicalAddress">
                Physical Address <span className="mandatory">*</span>
              </label>
              <Field
                name="physicalAddress"
                placeholder="Physical Address"
                maxLength="50"
                value={this.props.values.physicalAddress}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.physicalAddress &&
                  this.props.touched.physicalAddress
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.physicalAddress &&
              this.props.touched.physicalAddress ? (
                <div className={style.errMsg}>
                  {this.props.errors.physicalAddress}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="postalAddress">Postal Address (Optional)</label>
              <Field
                name="postalAddress"
                placeholder="Postal Address"
                className="form-control"
                maxLength="50"
                value={this.props.values.postalAddress}
                onChange={this.props.handleChange}
              />
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="cellNumber">
                Contact Number <span className="mandatory">*</span>
              </label>
              <Field
                name="cellNumber"
                placeholder="Cell Phone Number"
                maxLength="10"
                value={this.props.values.cellNumber}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.cellNumber && this.props.touched.cellNumber
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.cellNumber && this.props.touched.cellNumber ? (
                <div className={style.errMsg}>
                  {this.props.errors.cellNumber}
                </div>
              ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="compEmailAddress">
                Email Address <span className="mandatory">*</span>
              </label>
              <Field
                name="compEmailAddress"
                placeholder="Email Address"
                value={this.props.values.compEmailAddress}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.compEmailAddress &&
                  this.props.touched.compEmailAddress
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.compEmailAddress &&
              this.props.touched.compEmailAddress ? (
                <div className={style.errMsg}>
                  {this.props.errors.compEmailAddress}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="contactPerson">Contact person(Optional)</label>
              <Field
                name="contactPerson"
                placeholder="Contact Person"
                maxLength="20"
                value={this.props.values.contactPerson}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.contactPerson &&
                  this.props.touched.contactPerson
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.contactPerson &&
              this.props.touched.contactPerson ? (
                <div className={style.errMsg}>
                  {this.props.errors.contactPerson}
                </div>
              ) : null}
            </div>
          </div>

          <hr className={style.formBottomLine} />
          {Object.keys(this.props.errors).length > 0 &&
            this.state.nextClicked && (
              <div className="text-danger">
                Please fill all mandatory fields!
              </div>
            )}
          <div
            className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
          >
            <button
              type="button"
              className="btn form-primary-btn mb-3"
              onClick={this.props.navigateBack}
              disabled={this.props.pageIndex === 0}
            >
              Back
            </button>

            <button
              type="button"
              className="btn form-primary-btn mb-3"
              onClick={() => {
                this.props.navigateNext();
                this.setState({ nextClicked: true });
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInfo);
